import { useCallback, useState } from "react";
import { Button, Card } from "antd";

import { NewDistributionModal } from "./components/NewDistributionModal";
import { EditDistributionModal } from "./components/EditDistributionModal";
import {
  createDistributionAction,
  editDistributionAction,
  loadDistributionsAction
} from "store/distribution/distribution.actions";
import useListData, { LoadListDataParams } from "hooks/useListData";
import { IDistribution, IDistributionData } from "types/distribution.types";
import { useAppDispatch } from "store";
import { DistributionTable } from "./components/DistributionTable";

type DistributionFilters = {}

const Distribution = () => {
  const dispatch = useAppDispatch();
  const [open, setOpen] = useState(false);
  const [editableDistribution, setEditableDistribution] = useState<IDistribution>();
  const [submitting, setSubmitting] = useState(false);
  const handleLoadDistributions = useCallback((params: LoadListDataParams) => {
    return dispatch(loadDistributionsAction(params));
  }, [dispatch]);
  const {
    items,
    loading,
    pagination,
    onTableChange,
    loadData,
  } = useListData<IDistribution, DistributionFilters>(handleLoadDistributions, { defaultPageSize: 10 });
  const showModal = () => {
    setOpen(true);
  };
  const handleOk = async (data: IDistributionData) => {
    setSubmitting(true);
    try {
      await dispatch(createDistributionAction(data));
      await loadData({ page: pagination.current, pageSize: pagination.pageSize });
      handleClose();
    } finally {
      setSubmitting(false);
    }
  };
  const handleEdit = async (data: IDistributionData) => {
    if (!editableDistribution) return;
    setSubmitting(true);
    try {
      await dispatch(editDistributionAction({ id: editableDistribution.id, ...data }));
      await loadData({ page: pagination.current, pageSize: pagination.pageSize });
      handleCloseEdit();
    } finally {
      setSubmitting(false);
    }
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleOpenEdit = (data: IDistribution) => {
    setEditableDistribution(data);
  };
  const handleCloseEdit = () => {
    setEditableDistribution(undefined);
  }
  return (
    <>
      <Card
        title={(
          <>
            Рассылки
          </>
        )}
        extra={(
          <Button type="primary" onClick={showModal}>
            Новая рассылка
          </Button>
        )}
      >
        <DistributionTable
          pagination={pagination}
          loading={loading}
          onChange={onTableChange}
          data={items}
          onEdit={handleOpenEdit}
        />
      </Card>
      <NewDistributionModal
        submitting={submitting}
        open={open}
        onOk={handleOk}
        onCancel={handleClose}
      />
      <EditDistributionModal
        submitting={submitting}
        key={editableDistribution?.id}
        open={!!editableDistribution}
        initialValues={editableDistribution}
        onOk={handleEdit}
        onCancel={handleCloseEdit}
      />
    </>
  );
};

export default Distribution;